import { createAction, props } from '@ngrx/store';
import { Site } from 'graphql-api/gql-api-interfaces';

import { ISite } from '../models';

export const clearSites = createAction('[Sites] Clear Sites');

export const initSites = createAction('[Sites] Init sites');

export const loadSiteSelectorBackgroundSuccess = createAction(
  '[Sites] Load site selector background success',
  props<{ background: string }>(),
);

export const loadSitesSuccess = createAction(
  '[Sites] Load sites success',
  props<{ sites: Site[] }>(),
);

export const loadSitesFailed = createAction('[Sites] Load sites failed');
export const clearSubSites = createAction('[Sites] Clear Sub Sites');

export const setSelectedSite = createAction(
  '[Sites] Set selected site',
  props<{ site: ISite | null; skipLocationChange?: boolean }>(),
);

export const preloadSites = createAction(
  '[Sites] Preload sites',
  props<{ accountId: string }>(),
);

export const preloadSitesSuccess = createAction(
  '[Sites] Preload sites success',
  props<{ accountId: string; sites: Site[] }>(),
);

export const preloadFailure = createAction(
  '[Sites] Preload sites failure',
  props<{ accountId: string }>(),
);

export const loadAllSites = createAction('[Sites] Load all sites');

export const loadAllSitesSuccess = createAction(
  '[Sites] Load All Sites Success',
  props<{ sites: Site[] }>(),
);

export const updateCurrentSite = createAction(
  '[Sites] Update the current site',
  props<{ site: ISite }>(),
);
